import { createContext, useContext } from "react";

export const ToastContext = createContext(null);

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) throw new Error("Brak ToastProvider w drzewie aplikacji.");
  return context;
}
